import {CalenderWrapper} from '@mazraeapp/react-time-calender-kit';
import moment from 'jalali-moment';
import {useEffect, useState} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../button';

interface ISelectedDate {
  days: string;
  month: string;
  year: string;
}

interface IProps {
  title: string;
  titleClassName?: string;
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disablePastDates?: boolean;
  required?: boolean;
}

const DatePickerBottomSheet = ({
  title,
  titleClassName = 'text-sm font-medium',
  value,
  onChange,
  placeholder = 'انتخاب تاریخ',
  disablePastDates = false,
  required = false,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const [selectedDate, setSelectedDate] = useState<ISelectedDate>({
    days: moment().locale('fa').format('DD'),
    month: moment().locale('fa').format('MM'),
    year: moment().locale('fa').format('YYYY'),
  });

  // keep internal state in sync with external value
  useEffect(() => {
    if (!value) return;

    const m = moment(value, 'YYYY-MM-DD');
    if (!m.isValid()) return;

    setSelectedDate({
      days: m.format('DD'),
      month: m.format('MM'),
      year: m.format('YYYY'),
    });
  }, [value]);

  const changeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedDate(prev => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmitDate = () => {
    setIsOpen(false);
    onChange(`${selectedDate.year}/${selectedDate.month}/${selectedDate.days}`);
  };

  // Check if selected date is less than today's date
  const isPastDate = () => {
    if (!disablePastDates) return false;

    const today = moment().startOf('day'); // today at 00:00
    const selectedMoment = moment(
      `${selectedDate.year}/${selectedDate.month}/${selectedDate.days}`,
      'jYYYY-jMM-jDD',
    ).startOf('day'); // selected date at 00:00

    return selectedMoment.isBefore(today, 'day'); // disables if selected <= today
  };
  return (
    <div>
      <div>
        <span className={titleClassName}>{title}</span>
        {required && (
          <span className="text-sm font-medium text-red-500"> * </span>
        )}
      </div>

      <div className="relative" onClick={() => setIsOpen(true)}>
        <input
          className="w-full h-10 pl-10 pr-3 my-2 border-[1px] border-gray-400  rounded-lg pointer-events-none text-sm text-gray-800 focus:outline-none "
          value={value ?? ''}
          placeholder={placeholder} // Added placeholder prop
          readOnly
        />
        <i className="absolute text-xl text-gray-700 -translate-y-1/2 icon-nameCalendar left-3 top-1/2" />
      </div>

      <BottomSheet
        onDismiss={() => setIsOpen(false)}
        open={isOpen}
        blocking={true}
        className="custom-bottom-sheet"
      >
        <div className="relative flex flex-col w-full gap-4 p-6 CalenderWrapperBottomSheet-wrapper">
          <i
            className="absolute text-2xl text-gray-500 icon-nameClose-remove top-6 left-6"
            onClick={() => setIsOpen(false)}
          />
          <p className="flex justify-center w-full mt-2 text-lg text-gray-950 font-Regular">
            {title}
          </p>

          <div className="flex justify-between w-full px-3 py-2">
            <CalenderWrapper
              startYear={moment().add(2, 'jYear').jYear()}
              buttonClassName="border-[1px] text-md w-[95px] rounded-[8px] gap-3 px-1 h-[40px] flex text-gray-500 bg-white"
              buttonGroupClassName="w-full buttonGroup-wrapper flex justify-between items-center"
              days={selectedDate.days}
              month={selectedDate.month}
              year={selectedDate.year}
              calenderType="jalali"
              onChangeCalender={changeHandler}
              buttonWrapperClassName="min-w-[90px]"
              yearDuration={2}
            />
          </div>

          <div className="flex items-center justify-between w-full px-3">
            <div className="flex justify-end w-full">
              <Button
                className="flex items-center w-full gap-2 text-white border-none outline-none bg-farm-shop-500 disabled:opacity-50 disabled:bg-gray-400 disabled:text-white disabled:cursor-not-allowed"
                onClick={handleSubmitDate}
                disabled={isPastDate()}
              >
                تایید
              </Button>
            </div>
          </div>
        </div>
      </BottomSheet>
    </div>
  );
};

export default DatePickerBottomSheet;
